import { useFormik } from 'formik';
import * as Yup from 'yup';
import { changePassword } from '../core/_requests';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../core/Auth';

const ChangePasswordSchema = Yup.object().shape({
  password: Yup.string().min(6, 'Password must be atleast 6 character').required('Enter Password'),
  newPassword: Yup.string()
    .min(6, 'Password must be atleast 6 character')
    .required('Enter Current Password'),
  confirmNewPassword: Yup.string()
    .min(6, 'Password must be atleast 6 character')
    .required('Enter New Password'),
});

const initialValues = {
  password: '',
  newPassword: '',
  confirmNewPassword: '',
};

const ChangePassword = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { logout } = useAuth();
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: ChangePasswordSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true);
      try {
        const { data } = await changePassword(
          values.password,
          values.newPassword,
          values.confirmNewPassword
        );
        if (data) {
          logout();
        }
      } catch (error) {
        setStatus(error);
        setSubmitting(false);
        setLoading(false);
      }
    },
  });

  return (
    <div className='card mb-5 mb-xl-10'>
      <div
        className='card-header border-0 cursor-pointer'
        role='button'
        data-bs-toggle='collapse'
        data-bs-target='#kt_account_signin_method'
      >
        <div className='card-title m-0'>
          <h3 className='fw-bold m-0'>Change Password</h3>
        </div>
      </div>
      <div id='kt_account_settings_signin_method' className='collapse show'>
        <div className='card-body border-top p-9'>
          <form
            onSubmit={formik.handleSubmit}
            className='form fv-plugins-bootstrap5 fv-plugins-framework'
            noValidate
          >
            <div className='row mb-1'>
              <div className='col-lg-4'>
                <div className='fv-row mb-0 fv-plugins-icon-container'>
                  <label htmlFor='password' className='form-label fs-6 fw-bold mb-3'>
                    Current Password
                  </label>
                  <input
                    {...formik.getFieldProps('password')}
                    type='password'
                    className={`form-control form-control-lg form-control-solid ${
                      formik.touched.password && formik.errors.password ? 'is-invalid' : ''
                    }`}
                    id='password'
                    name='password'
                  />
                  {formik.touched.password && formik.errors.password && (
                    <div className='invalid-feedback'>{formik.errors.password}</div>
                  )}
                </div>
              </div>

              <div className='col-lg-4'>
                <div className='fv-row mb-0 fv-plugins-icon-container'>
                  <label htmlFor='newPassword' className='form-label fs-6 fw-bold mb-3'>
                    New Password
                  </label>
                  <input
                    {...formik.getFieldProps('newPassword')}
                    type='password'
                    className={`form-control form-control-lg form-control-solid ${
                      formik.touched.newPassword && formik.errors.newPassword ? 'is-invalid' : ''
                    }`}
                    id='newPassword'
                    name='newPassword'
                  />
                  {formik.touched.newPassword && formik.errors.newPassword && (
                    <div className='invalid-feedback'>{formik.errors.newPassword}</div>
                  )}
                </div>
              </div>

              <div className='col-lg-4'>
                <div className='fv-row mb-0 fv-plugins-icon-container'>
                  <label htmlFor='confirmNewPassword' className='form-label fs-6 fw-bold mb-3'>
                    Confirm New Password
                  </label>
                  <input
                    {...formik.getFieldProps('confirmNewPassword')}
                    type='password'
                    className={`form-control form-control-lg form-control-solid ${
                      formik.touched.confirmNewPassword && formik.errors.confirmNewPassword
                        ? 'is-invalid'
                        : ''
                    }`}
                    id='confirmNewPassword'
                    name='confirmNewPassword'
                  />
                  {formik.touched.confirmNewPassword && formik.errors.confirmNewPassword && (
                    <div className='invalid-feedback'>{formik.errors.confirmNewPassword}</div>
                  )}
                </div>
              </div>
            </div>

            <div className='form-text mb-5'>
              Password must be at least 6 character and contain symbols
            </div>

            <div className='d-flex'>
              <button
                type='submit'
                className='btn btn-primary me-2 px-6'
                disabled={formik.isSubmitting || !formik.isValid}
              >
                {loading ? 'Updating...' : 'Update Password'}
              </button>
              <button
                type='button'
                className='btn btn-color-gray-500 btn-active-light-primary px-6'
                onClick={() => navigate(-1)}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
